/**
 * Google OAuth 配置
 * 使用 Google Identity Services (GIS) - 弹窗模式
 * 不需要重定向，所有操作在弹窗中完成
 *
 * 安全特性：
 * - PKCE (Proof Key for Code Exchange) - 防止授权码拦截攻击
 * - STATE 验证 - 防止 CSRF 攻击
 * - NONCE 验证 - 防止重放攻击，绑定 ID Token 和客户端会话
 */

// Google Client ID（从 Google Cloud Console 获取）
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || ''

// Google OAuth 重定向 URI
export const GOOGLE_REDIRECT_URI = `${window.location.origin}/google-callback.html`

// Google OAuth 配置: https://developers.google.com/identity/gsi/web/reference/js-reference?hl=zh-cn#IdConfiguration
export const GOOGLE_CONFIG = {
  // Client ID
  clientId: GOOGLE_CLIENT_ID,

  // 重定向 URI
  redirectURI: GOOGLE_REDIRECT_URI,

  // TODO:请求的权限范围
  scope: 'email profile',

  // 是否为 FedCM 按钮流程启用自动选择选项。如果启用，系统会自动为具有有效 Google 会话的回访用户登录，从而绕过账号选择器提示。默认值为 false。
  button_auto_select: false,

  auto_select: false,

  // 点击外部是否取消
  cancel_on_tap_outside: false,

  // 针对 One Tap 启用 FedCM
  use_fedcm_for_prompt: true,

  // 启用 FedCM 按钮流程，仅当 FedCM 按钮流程处于启用状态时
  use_fedcm_for_button: true,
}

/**
 * Google Console 配置说明：
 *
 * 1. 授权的 JavaScript 来源（必须配置）
 *    - 生产环境：https://yourdomain.com
 *    - 开发环境：http://localhost:5173
 *
 * 2. 授权的重定向 URI（使用 GIS 不需要，但建议配置一个兜底）
 *    - https://yourdomain.com
 *
 * 注意：必须使用 HTTPS，HTTP 不支持（localhost 除外）
 */
